import React from "react";
import "./ValidationModal.css";
import GoldenButton from "../GoldenButton/GoldenButton";

const ValidationModal = ({ message, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3 className="modal-title">Attention</h3>
        <p className="modal-message">{message}</p>

        <GoldenButton onClick={onClose}>
          Understood
        </GoldenButton>
      </div>
    </div>
  );
};

export default ValidationModal;
